import { create } from 'zustand';

// Local UI state for the live-traffic overlay. Kept in its own tiny store (rather
// than the shared mapStore/uiStore) so the traffic feature is fully self-contained
// within components/map: the layers-panel toggle (MapControls) and the overlay
// renderer (TrafficLayer) are sibling components that share only this flag.
//
// Not persisted: the overlay is an on-demand, session-only view and defaults OFF.
interface TrafficState {
  enabled: boolean;
  toggle: () => void;
  setEnabled: (enabled: boolean) => void;
}

export const useTrafficStore = create<TrafficState>((set) => ({
  enabled: false,
  toggle: () => set((s) => ({ enabled: !s.enabled })),
  setEnabled: (enabled) => set({ enabled }),
}));
